import { SPECIALTY_FLU_VACCINATIONS } from '../types/FilterChoice';

/** When a suggestion for these topics is chosen, we default to the 'online appointments' filter. */
export const ALWAYS_ONLINE_BOOKED_TOPICS = [
  'Audiologist',
  'Audiology',
  'Chiropractor',
  'Counselling',
  'Counsellor',
  'COVID-19 Vaccinations',
  'Dentist',
  'Dentistry',
  'GP',
  'Optometrist',
  'Optometry',
  'Physiotherapist',
  'Physiotherapy',
  'Podiatrist',
  'Podiatry',
  'Psychologist',
  'Psychology',
  'Skin Cancer Physician',
  'Skin Cancer',
  SPECIALTY_FLU_VACCINATIONS,
];
